let mobileMenu = document.getElementById("mainmenu-mobile-btn");
let menuState = document.getElementById("menu-state");

mobileMenu.addEventListener("shown.bs.dropdown", function () {
  let text = document.getElementById("huvudmenyn-visas").value;
  menuState.innerText = text;
  document.body.style.overflow = "hidden";
  scrollTo(0, 0);
});

mobileMenu.addEventListener("hidden.bs.dropdown", function () {
  let text = document.getElementById("huvudmenyn-dold").value;
  menuState.innerText = text;
  document.body.style.overflow = "auto";
});

if (document.getElementById("toppbildlankar")) {
  document
    .getElementById("skipToContenLink")
    .addEventListener("click", function (event) {
      event.preventDefault();
      location.hash = "#toppbildlankar";
    });
}

// On collapse open
var loginDropdown = document.getElementById('loginAccordion');
if (loginDropdown) {
  loginDropdown.addEventListener('show.bs.collapse', function () {
      
      setTimeout(function() {
          loginDropdown.querySelector('#collapseLogin div:first-child li:first-child a').focus();  
      })
  })
}
 
// On collapse close
var loginbutton = document.getElementById('loginbutton');
if (loginbutton) {
  loginDropdown.addEventListener('hidden.bs.collapse', function () {
      
      setTimeout(function() {
        loginbutton.focus();  
      })
  })
}
